<div class="row">
  <div class="col-lg-12">
    <div class="col-lg-12">
      <div class="card">
        <!-- Card header -->
        <div class="card-header border-0">
          <div class="row">
            <h3 class="mb-0">Batches for {{moduleInfo.name}}</h3>
          </div>
        </div>
        <!-- Light table -->
        <div class="table-responsive">
          <table class="table align-items-center table-flush table-hover">
            <!-- <thead>
                    <tr>
                        <th colspan="4" class="text-right"> Total : </th><th class="text-right">₦{{this.util.numberWithCommas(sumTotal)}}</th>
                    </tr>
                </thead> -->
            <thead class="thead-light">
              <tr>
                <th> Name </th>
                <!-- <th> Status </th> -->
                <th> Start Date</th>
                <th> End Date</th>
                <!-- <th class="mb-0"> Action</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of moduleBatches" class="handCusor" (click)="navigateToDetails(item.id)">
                <td>{{item.name}}</td>
                <!-- <td
                  [ngClass]="{ 'bg-red': item.isCancelled, 'bg-green': !item.isCancelled && !isExpired(item),'bg-yellow': !item.isCancelled && isExpired(item) }">
                  {{ item.isCancelled ?
                  'Cancelled' : isExpired(item)? 'Expired':'Active'}}</td> -->
                <td>{{this.util.formatDate(item.startDate)}}</td>
                <td>{{this.util.formatDate(item.endDate)}}</td>

                <!-- <td class="mb-0">
                  <span><i class="fas fa-edit handCusor text-primary mr-3" (click)="editBatch(item)">Edit</i></span>
                  <span><i class="fas fa-eye handCusor text-primary">View</i></span>
                </td> -->
              </tr>
            </tbody>
          </table>
          <p *ngIf="moduleBatches.length<=0" class="text-center">No Available Batch</p>
        </div>
      </div>
    </div>
  </div>
</div>